import React, { Component } from "react";
import s from "./index.module.scss";
import classNames from "classnames/bind";
import { Tooltip } from "./../../../libraries/mdl-temporary/tooltip/Tooltip";
import { mReadyToPaint } from "@masonite/svg-icons";

const cx = classNames.bind(s);

export class Swatches extends Component {
    constructor(props) {
        super(props);
        this.itemsRef = React.createRef();
        this.state = {
            moreItemsLeft: false,
            moreItemsRight: false
        };
    }

    shouldComponentUpdate(nextProps) {
        return nextProps !== this.props;
    }

    componentDidMount() {
        this.itemsRef.current.scrollLeft = this.props.scrollLeft;
    }

    componentWillUnmount() {
        if (this.props.handleUnmount) {
            const ref = this.itemsRef.current;
            const scrollLeft = ref.scrollLeft;
            this.props.handleUnmount(scrollLeft);
        }
    }

    handleScroll = () => {
        const ref = this.itemsRef.current;
        const scrollLeft = ref.scrollLeft;
        const scrollRight = ref.scrollWidth - ref.clientWidth - ref.scrollLeft;

        if (this.props.scrollHandler) {
            this.props.scrollHandler(scrollLeft);
        }

        this.setState({
            moreItemsLeft: scrollRight > 0,
            moreItemsRight: scrollLeft > 0
        });
    };

    render() {
        const {
            className = "",
            values = [],
            borderRadius = null,
            showLabels = false,
            wrap = false,
            swatchSize = null,
            selectedSwatch = null,
            selectHandler = null,
            showImageTooltip = false,
            showTooltip = false,
            showTooltipFor,
            handleTooltipClick,
            tooltipBgSize = null
        } = this.props;

        const { moreItemsLeft, moreItemsRight } = this.state;

        const items =
            values &&
            values.map(item => {
                const {
                    color: backgroundColor,
                    image: backgroundImage = "",
                    value,
                    label
                } = item;

                const size = swatchSize && {
                    height: `${swatchSize}px`,
                    width: `${swatchSize}px`
                };

                const style = {
                    backgroundColor,
                    backgroundImage: backgroundImage
                        ? `url(${backgroundImage})`
                        : "none",
                    borderRadius,
                    ...size
                };

                const swatchClasses = [
                    s.item,
                    selectedSwatch === value && s.selected
                ]
                    .filter(c => c)
                    .join(" ");

                return (
                    <div key={value} className={[s["item-wrapper"]]}>
                        <div className={cx("tooltip-wrapper")}>
                            {showTooltip ? (
                                <Tooltip
                                    showIcon={false}
                                    message={label}
                                    image={backgroundImage}
                                    tooltipBgSize={tooltipBgSize}
                                    showOnCursor
                                    controlledDisplay={showTooltipFor === value}
                                    {...(handleTooltipClick
                                        ? {
                                              handleClick: () =>
                                                  handleTooltipClick(value)
                                          }
                                        : {})}
                                >
                                    {backgroundImage === "paintIcon" ? (
                                        <div
                                            className={swatchClasses}
                                            style={{
                                                ...style,
                                                fill: "#99c221",
                                                backgroundColor: "#f3f3f3"
                                            }}
                                            onClick={() => {
                                                if (selectHandler)
                                                    selectHandler(value);
                                            }}
                                        >
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: mReadyToPaint
                                                }}
                                            />
                                        </div>
                                    ) : (
                                        <div
                                            className={swatchClasses}
                                            style={style}
                                            onClick={() => {
                                                if (selectHandler)
                                                    selectHandler(value);
                                            }}
                                        />
                                    )}
                                </Tooltip>
                            ) : (
                                <div
                                    className={swatchClasses}
                                    style={style}
                                    onClick={() => {
                                        if (selectHandler) selectHandler(value);
                                    }}
                                />
                            )}
                        </div>
                        {showLabels && (
                            <label className={s.label}>{label}</label>
                        )}
                    </div>
                );
            });

        const shadowLeftClasses = [
            s.more,
            s["more--left"],
            moreItemsLeft && s["more--show"]
        ]
            .filter(c => c)
            .join(" ");

        const shadowRightClasses = [
            s.more,
            s["more--right"],
            moreItemsRight && s["more--show"]
        ]
            .filter(c => c)
            .join(" ");

        const itemsClasses = [s.items, wrap && s["items--wrapping"]]
            .filter(c => c)
            .join(" ");

        return (
            <div className={cx(["items-wrapper"], className)}>
                <div className={shadowLeftClasses} />
                <div className={shadowRightClasses} />
                <div
                    className={itemsClasses}
                    ref={this.itemsRef}
                    onScroll={this.handleScroll}
                >
                    {items}
                </div>
            </div>
        );
    }
}

export default Swatches;
